import React from "react";
import { motion } from "framer-motion";
import BlogCard from "./BlogCard";
import ApprovalBlogCard from "./ApprovalBlogCard";
import { useAuth } from "../Auth/AuthContext";

const BlogSection = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const user = authState.user;
    const admin = role === "Admin";

    // Content for unapproved users
    const unApprovedContent = {
        title: "You are not approved yet",
        excerpt: "Hey, thank you for joining us! Please wait for approval. Our team will review and approve your access shortly.",
        image: "./Images/PendingApproval.png",
        author: "Adspace",
        date: "",
        readMoreLink: "https://adspace-tech.net/",
    };

    // Blogs List
    const blogs = [
        {
            title: "Maximizing ROI with Google Ads: Best Practices",
            excerpt: "Discover how to optimize your Google Ads campaigns to maximize return on investment (ROI) with expert tips and strategies...",
            image: "./Images/Roi-google.jpg",
            author: "Alice Carter",
            date: "October 16, 2024",
            readMoreLink: "https://adspace-tech.net/",
        },
        {
            title: "Understanding Google AdX: A Complete Guide",
            excerpt: "Google AdX offers advanced programmatic advertising solutions. Learn how it differs from Google Ads and how it benefits publishers...",
            image: "./Images/Google-Adx.png",
            author: "Mark Reynolds",
            date: "October 10, 2024",
            readMoreLink: "https://adspace-tech.net/",
        },
        {
            title: "Google Ads vs. Google AdX: Which is Right for Your Business?",
            excerpt: "Choosing between Google Ads and Google AdX can be tricky. This article breaks down the differences and helps you decide what's best for your business...",
            image: "./Images/googlevsadx.png",
            author: "Samantha Lee",
            date: "October 8, 2024",
            readMoreLink: "https://adspace-tech.net/",
        },
        {
            title: "How to Improve Ad Quality Score in Google Ads",
            excerpt: "Improving your Google Ads Quality Score can lead to lower costs and better ad performance. Learn key factors that influence this score...",
            image: "./Images/imporveadsquality.jpg",
            author: "David Collins",
            date: "October 5, 2024",
            readMoreLink: "https://adspace-tech.net/",
        },
        {
            title: "Monetizing Your Website with Google AdX",
            excerpt: "If you're a publisher looking to maximize revenue, Google AdX offers advanced tools for programmatic advertising. Here's how to get started...",
            image: "./Images/monitizewebsite.png",
            author: "Emily Johnson",
            date: "October 2, 2024",
            readMoreLink: "https://adspace-tech.net/",
        },
    ];
    var contactBlog = {
        title: "Get in Touch with Us",
        excerpt: "In today's digital world, staying connected is more important than ever. Whether you have questions, need assistance, or want to explore collaboration opportunities, our team is just a message away!",
        image: "./Images/microsoftteams.png",
        author: "Adspace Admin",
        date: new Date().toDateString(), // Properly formatted date
        readMoreLink: "https://teams.live.com/l/invite/FEAeu3E6yc8ggyIYAQ",
    };

    return (
        <motion.div
            className="container mx-auto px-4 py-10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Show blogs if user is approved & not an admin */}
                <motion.div
                    key={0}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1 * 0.1, duration: 0.3 }}
                >
                    <BlogCard {...contactBlog} />
                </motion.div>
                {admin === true || user.isApprovedByAdmin === true ? (
                    blogs.map((blog, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1, duration: 0.3 }}
                        >
                            <BlogCard {...blog} />
                        </motion.div>
                    ))
                ) : (
                    /* Show approval message if user is not approved */
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                        className="col-span-1 sm:col-span-2 lg:col-span-3 flex justify-center"
                    >
                        <ApprovalBlogCard {...unApprovedContent} />
                    </motion.div>
                )}
            </div>
        </motion.div>
    );
};

export default BlogSection;
